// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2nU4z","name":"Header_name__19caP","birthday":"Header_birthday__3rm0x","skeleton":"Header_skeleton__10V2w"};